import React, { useEffect, useState, useMemo } from "react";
import { Typography, Box } from "@mui/material";
import '../CardPieces/CardPieces.scss';
import PickStatsChoicesCard from "./PickStatsChoicesCard";
import { useTheme } from "@emotion/react";
import useMediaQuery from "@mui/material/useMediaQuery";


const PickStatsCard = ({ userPicksFromDB, pickState, setPickState, prop, interval, selectedGameId, hasGameStarted, isGameFinal, displayIndex }) => {
    //console.log("INTERVAL: ", interval);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const propText = prop?.propText;
    const actualTotal = prop?.actualTotal;
    const correctOption = prop?.correctOption;
    const points = prop?.points;
    const correctOptions = prop?.correctOptions;
    const propHeader = prop?.propHeader;
    const highlightProp = prop?.highlight;
    const highlightColor = prop?.highlightColor || '#CC293C';
    const topHeaderDisplay = useMemo(() => {
        const result = propHeader || `Prop #${displayIndex}`;
        
        return result;
    }, [propHeader, displayIndex, prop]);
    const logo = prop?.logo;
    //console.log("Prop Header: ", propHeader, "highlight", highlightProp, "Prop:" , prop, "Top Header Display: ", topHeaderDisplay);

    const getDynamicFontSize = (text, baseSize = 16, threshold = isMobile ? 12 : 36, minSize = 10, step = 4, stepReduction = 1) => {
        if (typeof text !== 'string') return baseSize;
    
        const excessLength = text.length - threshold;
    
        if (excessLength <= 0) {
            return baseSize;
        }
    
        const reductions = Math.floor(excessLength / step) * stepReduction;
        const newSize = baseSize - reductions;

        console.log("Text: ", text, "Base Size: ", baseSize, "Threshold: ", threshold, "Min Size: ", minSize, "Step: ", step, "Step Reduction: ", stepReduction, "Excess Length: ", excessLength, "New Size: ", newSize);
    
        return Math.max(minSize, newSize);
    };
    
    return (
        <Box className="quick-pick-card-container"
            sx={{
                border: highlightProp ? `10px solid ${highlightColor}` : '',
                borderRadius: highlightProp ? '16px' : '',
            }}    
        >
            <Box className="quick-pick-card-top-border" sx={{ backgroundColor: correctOption === 'Void' ? '#000000' : ''}}>
                <Typography 
                    className="quick-pick-card-top-border-left-text"
                    sx={{ 
                        color: '#002129',
                        fontSize: `${getDynamicFontSize(topHeaderDisplay)}px` 
                    }}    
                >
                    {topHeaderDisplay}
                </Typography>
                <Typography className="quick-pick-card-top-border-right-text" sx={{ color: correctOption === 'Void' ? '#fff' : '' }}>
                    {correctOption === 'Void' ? 'VOID' : `${points} Point${points > 1 ? 's' : ''}`}
                </Typography>
            </Box>
            <Box className="quick-pick-card-info">
                {logo &&
                    <Box 
                        sx={{
                            alignContent: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '8px 0',
                        }}
                    >
                        <img
                            className="quick-pick-card-logo"
                            src={logo}
                            alt="Logo"
                            style={{ maxWidth: '150px', height: 'auto', maxHeight: '100px', objectFit: 'contain' }}
                        />
                    </Box>
                }
                <Typography className="quick-pick-card-info-text">
                    {propText}
                </Typography>
            </Box>
            
            <PickStatsChoicesCard 
                hasGameStarted={hasGameStarted}
                isGameFinal={isGameFinal}
                prop={prop}
                selectedGameId={selectedGameId}
                correctOption={correctOption}
                correctOptions={correctOptions}
            />
            
            
            <Box className="quick-pick-card-bottom-border">
                <Typography className="quick-pick-card-bottom-border-text">
                    Result: 
                </Typography>
                <Typography className="quick-pick-card-bottom-border-text">
                    {actualTotal ? actualTotal : correctOption === 'Multiple Answers' ? 'Tie' : correctOption ? correctOption : 'Pending'}
                </Typography>
            </Box>
        </Box>
    )
}

export default PickStatsCard;